/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { Outlet } from 'react-router-dom';
import QuestionnaireSideBarItem from './QuestionnaireSideBarItem';
import * as S from './Questionnaire.styled';

export default function Questionaire(props: any) {
    return (
        <>
            <S.Container>
                <S.SideBar>
                    <QuestionnaireSideBarItem />
                </S.SideBar>
                <S.Main>
                    <Outlet />
                </S.Main>
            </S.Container>
        </>
    );
}
